document.addEventListener('DOMContentLoaded', function() {
    const pricePerUnitContainer = document.getElementById('price_per_unit');
    const pricePerUnitSpans = document.querySelectorAll('.price_per_unit');

    function getVariantIdFromUrl() {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get('variant');
    }

    function getFirstVariantId() {
        return pricePerUnitSpans.length > 0 ? pricePerUnitSpans[0].getAttribute('data-variant-id') : null;
    }

    function togglePricePerUnit() {
        let variantId = getVariantIdFromUrl();
        if (!variantId) {
            variantId = getFirstVariantId();
        }

        let isVisible = false;

        pricePerUnitSpans.forEach(element => {
            if (element.getAttribute('data-variant-id') === variantId) {
                element.style.display = 'inline-block';
                isVisible = true;
            } else {
                element.style.display = 'none';
            }
        });

        pricePerUnitContainer.style.display = isVisible ? 'inline-block' : 'none';
    }

    // Initial check
    togglePricePerUnit();

    // Use MutationObserver to watch for changes in the DOM
    const observer = new MutationObserver(togglePricePerUnit);

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

    // Update display when the popstate event is triggered (e.g., browser back/forward buttons)
    window.addEventListener('popstate', togglePricePerUnit);

    // Update display when the URL changes due to history pushState/replaceState
    const originalPushState = history.pushState;
    const originalReplaceState = history.replaceState;
    history.pushState = function() {
        originalPushState.apply(this, arguments);
        togglePricePerUnit();
    };
    history.replaceState = function() {
        originalReplaceState.apply(this, arguments);
        togglePricePerUnit();
    };
});